export const CHANGE_LANG = 'CHANGE_LANG'

export const UPDATE_TOKEN = 'UPDATE_TOKEN';
export const UPDATE_ID_TOKEN = 'UPDATE_ID_TOKEN';

export const ADD_NOTIFICATION = 'ADD_NOTIFICATION'
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION'

export const CHANGE_CUSTOMER = 'CHANGE_CUSTOMER'
export const GET_CUSTOMERS_SUCCESS = 'GET_CUSTOMERS_SUCCESS'
export const GET_CUSTOMERS_PROCESSING = 'GET_CUSTOMERS_PROCESSING'
export const GET_CUSTOMERS_FAILURE = 'GET_CUSTOMERS_FAILURE'

export const CHANGE_ALIAS = 'CHANGE_ALIAS'
export const CHANGE_EMAIL = 'CHANGE_EMAIL'

export const PROCESSING = 'PROCESSING'
export const DONE = 'DONE'
export const ERROR = 'ERROR'

